<span>{{ message }}</span>
<button type="button" data-dismiss="alert" aria-label="Close" class="close" (click)="remove()">
  <i class="material-icons">close</i>
</button>
